// import { updatePassFeeToCustomer } from '@api';
import {
  fetchAllowedAutoSettlementCurrencies,
  updateAutoPayoutEnabled,
  updateOverPaymentToCustomer,
  updatePassSettlementFeeToCustomer,
  updatePushFeesToCustomer,
  updateUnderPaymentToCustomer
} from '@basqet-dashboard/common/api';
import { Button, FormInput } from '@basqet-dashboard/common/components';
// import { APP_NAME } from '@basqet-dashboard/common/config';
// import { UserContext } from '@basqet-dashboard/common/context';
// import { useSessionStorage } from '@basqet-dashboard/common/hooks';
import { useFetchKeys } from '@hooks/queries';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

const PaymentSettings = () => {
  const { keys, refetch } = useFetchKeys();
  // const { user, setUser } = useContext(UserContext);

  // const [isLoading, setIsLoading] = useState(false);
  const [isLoadingDispute, setIsLoadingDispute] = useState(false);
  const [isLoadingPayment, setIsLoadingPayment] = useState(false);
  const [allowedAutoSettlementCurrencies, setAllowedAutoSettlementCurrencies] = useState([]);
  // const [passFeeToCustomer, setPassFeeToCustomer] = useState(user?.passFeeToCustomer);
  const [allowUnderPaymentToCustomer, setAllowUnderPaymentToCustomer] = useState();
  const [allowOverPaymentToCustomer, setAllowOverPaymentToCustomer] = useState();
  const [pushFeesToCustomer, setPassFeesToCustomer] = useState();
  const [passSettlementFeeToCustomer, setPassSettlementFeeToCustomer] = useState();
  const [autoPayoutEnabled, setAutoPayoutEnabled] = useState();
  // const [merchant, setMerchant] = useSessionStorage(APP_NAME);

  useEffect(() => {
    setAllowOverPaymentToCustomer(!!keys.allow_overpayment_refund || false);
    setAllowUnderPaymentToCustomer(!!keys.allow_underpayment || false);
    setPassFeesToCustomer(!!keys.pass_fee_to_customer || false);
    setPassSettlementFeeToCustomer(!!keys.pass_settlement_fee_to_customer || false);
    setAutoPayoutEnabled(!!keys.auto_payout_enabled || false);
  }, [keys]);

  useEffect(() => {
    const fetchAllowedCurrencies = async () => {
      try {
        const data = await fetchAllowedAutoSettlementCurrencies();
        setAllowedAutoSettlementCurrencies(data.data.allowed_currencies || []);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch allowed auto settlement currencies:', error);
      }
    };
    fetchAllowedCurrencies();
  }, []);

  const canShowAutoPayout = () => {
    if (!keys?.settlement_currency) return false;
    return allowedAutoSettlementCurrencies.includes(parseInt(keys.settlement_currency));
  };

  // const togglePassFeeToCustomer = () => {
  //   setPassFeeToCustomer((passFeeToCustomer) => !passFeeToCustomer);
  // };

  const toggleAllowUnderPaymentToCustomer = () => {
    setAllowUnderPaymentToCustomer((allowUnderPaymentToCustomer) => !allowUnderPaymentToCustomer);
  };

  const toggleAllowOverPaymentToCustomer = () => {
    setAllowOverPaymentToCustomer((allowOverPaymentToCustomer) => !allowOverPaymentToCustomer);
  };

  const togglePushFeesToCustomer = () => {
    setPassFeesToCustomer((pushFeesToCustomer) => !pushFeesToCustomer);
  };

  const togglePassSettlementFeeToCustomer = () => {
    setPassSettlementFeeToCustomer((passSettlementFeeToCustomer) => !passSettlementFeeToCustomer);
  };

  const toggleAutoPayoutEnabled = () => {
    setAutoPayoutEnabled((autoPayoutEnabled) => !autoPayoutEnabled);
  };

  // const savePaymentSettings = async () => {
  //   setIsLoading(true);
  //   const { merchantUser, token } = merchant;

  //   try {
  //     await updatePassFeeToCustomer({
  //       pass_fee_to_customer: passFeeToCustomer
  //     });

  //     toast.success(`Payment settings successfully changed`);

  //     merchantUser.passFeeToCustomer = passFeeToCustomer;
  //     const updatedMerchant = {
  //       token,
  //       merchantUser
  //     };
  //     setUser(merchantUser);
  //     setMerchant(updatedMerchant);
  //   } catch (error) {
  //     const {
  //       response: {
  //         data: { message }
  //       }
  //     } = error;

  //     toast.error(message);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const saveDisputeSettings = async () => {
    setIsLoadingDispute(true);

    try {
      await updateOverPaymentToCustomer({
        allow_overpayment_refund: allowOverPaymentToCustomer
      });

      await updateUnderPaymentToCustomer({
        allow_underpayment: allowUnderPaymentToCustomer
      });

      toast.success(`Dispute settings successfully changed`);

      refetch();
    } catch (error) {
      const {
        response: {
          data: { message }
        }
      } = error;

      toast.error(message);
    } finally {
      setIsLoadingDispute(false);
    }
  };

  const savePaymentSettings = async () => {
    setIsLoadingPayment(true);

    try {
      await updatePushFeesToCustomer({
        push_fees_to_customer: pushFeesToCustomer
      });

      await updatePassSettlementFeeToCustomer({
        pass_settlement_fee_to_customer: passSettlementFeeToCustomer
      });

      // Only save auto-payout if settlement currency is in allowed list
      if (canShowAutoPayout()) {
        await updateAutoPayoutEnabled({
          auto_payout_enabled: autoPayoutEnabled
        });
      }

      toast.success(`Payment settings successfully changed`);

      refetch();
    } catch (error) {
      const {
        response: {
          data: { message }
        }
      } = error;

      toast.error(message);
    } finally {
      setIsLoadingPayment(false);
    }
  };

  return (
    <div className="card settlements">
      {/* <h3 className="card__header">Payment settings</h3> */}
      {/* <div className="settlements__settings">
        <FormInput
          type="checkbox"
          register={{ onChange: togglePassFeeToCustomer }}
          name="pass_fee_to_customer"
          label="Charge processing fee to customers"
          id="pass_fee_to_customer"
          checked={Boolean(passFeeToCustomer)}
        />

        <Button
          type="submit"
          isLoading={isLoading}
          disabled={user?.passFeeToCustomer === passFeeToCustomer}
          onClick={savePaymentSettings}>
          Save changes
        </Button>
      </div> */}

      <h3 className="card__header">Dispute settings</h3>
      <div className="settlements__settings">
        <FormInput
          data-testid="dispute-allow-underpayment-checkbox"
          type="checkbox"
          register={{ onChange: toggleAllowUnderPaymentToCustomer }}
          name="allow_underpayment"
          label="Allow transactions with underpayment to be credited (not refunded)"
          id="allow_underpayment"
          checked={Boolean(allowUnderPaymentToCustomer)}
        />

        <FormInput
          data-testid="dispute-allow-overpayment-refund-checkbox"
          type="checkbox"
          register={{ onChange: toggleAllowOverPaymentToCustomer }}
          name="allow_overpayment_refund"
          label="Automatically refund overpayments to customer "
          id="allow_overpayment_refund"
          checked={Boolean(allowOverPaymentToCustomer)}
        />

        <Button
          data-testid="dispute-settings-save-button"
          type="submit"
          isLoading={isLoadingDispute}
          disabled={
            keys.allow_underpayment === allowUnderPaymentToCustomer &&
            keys.allow_overpayment_refund === allowOverPaymentToCustomer
          }
          onClick={saveDisputeSettings}>
          Save changes
        </Button>
      </div>

      <h3 className="card__header">Payment processing settings</h3>
      <div className="settlements__settings">
        <FormInput
          data-testid="payment-charge-processing-fee-checkbox"
          type="checkbox"
          register={{ onChange: togglePushFeesToCustomer }}
          name="push_fees_to_customer"
          label="Charge processing fee to customer"
          id="push_fees_to_customer"
          checked={Boolean(pushFeesToCustomer)}
        />

        <FormInput
          data-testid="payment-charge-settlement-fee-checkbox"
          type="checkbox"
          register={{ onChange: togglePassSettlementFeeToCustomer }}
          name="pass_settlement_fee_to_customer"
          label="Charge settlement fee to customer"
          id="pass_settlement_fee_to_customer"
          checked={Boolean(passSettlementFeeToCustomer)}
        />

        {canShowAutoPayout() && (
          <FormInput
            data-testid="payment-auto-payout-checkbox"
            type="checkbox"
            register={{ onChange: toggleAutoPayoutEnabled }}
            name="auto_payout_enabled"
            label="Automatically payout to bank after NGN settlement"
            id="auto_payout_enabled"
            checked={Boolean(autoPayoutEnabled)}
          />
        )}

        <Button
          data-testid="payment-settings-save-button"
          type="submit"
          isLoading={isLoadingPayment}
          disabled={
            keys.push_fees_to_customer === pushFeesToCustomer &&
            keys.pass_settlement_fee_to_customer === passSettlementFeeToCustomer &&
            (!canShowAutoPayout() || keys.auto_payout_enabled === autoPayoutEnabled)
          }
          onClick={savePaymentSettings}>
          Save changes
        </Button>
      </div>
    </div>
  );
};

export { PaymentSettings };
